<template>
    <div>
        <div class="noselect" id="app" style="padding: 0px;margin: 0px;">
            <router-view></router-view>
        </div>
        <div element-loading-text="正在加载中" style="height: 100px; width: 100px" v-loading.fullscreen.lock="loading"
            v-show="loading" />

        <div class="my-loading" ref="gifDiv" style="display: none;background-color: white;border-radius: 20px;">
            <img src="./assets/loading.gif" />
        </div>
        <UpgradeNotice
            v-if="showUpgradeNotice"
            :start-time="announcementStartText"
            :end-time="announcementEndText"
        />
    </div>
</template>

<script>

import { mapState } from 'vuex'
import UpgradeNotice from '@/components/UpgradeNotice/index.vue'
import { getListByDictType } from '@/api/sys/dictData'

export default {
    name: 'App',
    components: {
        UpgradeNotice
    },
    data() {
        return {
            showUpgradeNotice: false,
            announcementStartText: '',
            announcementEndText: ''
        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.loading.loading
        }),
    },
    created() {
        logger.logo()
        this.loadUpgradeAnnouncement()
    },
    mounted() {
    },
    methods: {
        // 字典值 2026:10:27:19:00:00 -> 2026-10-27 19:00:00
        formatDictTime(value) {
            if (!value) return ''
            const parts = String(value).split(':')
            if (parts.length < 6) return ''
            const [y, m, d, hh, mm, ss] = parts
            return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
        },
        parseDictTime(value) {
            const formatted = this.formatDictTime(value)
            if (!formatted) return null
            const date = new Date(formatted.replace(/-/g, '/'))
            return Number.isNaN(date.getTime()) ? null : date
        },
        async loadUpgradeAnnouncement() {
            try {
                const res = await getListByDictType('sys_announcement')
                if (!res || res.code !== 200 || !Array.isArray(res.data)) {
                    this.showUpgradeNotice = false
                    return
                }
                const list = res.data
                const startItem = list.find(item => item.dictLabel === '开始时间')
                const endItem = list.find(item => item.dictLabel === '结束时间')
                const startRaw = startItem && startItem.dictValue
                const endRaw = endItem && endItem.dictValue
                const startDate = this.parseDictTime(startRaw)
                const endDate = this.parseDictTime(endRaw)
                if (!startDate || !endDate) {
                    this.showUpgradeNotice = false
                    return
                }
                const now = new Date()
                if (now >= startDate && now <= endDate) {
                    this.announcementStartText = this.formatDictTime(startRaw)
                    this.announcementEndText = this.formatDictTime(endRaw)
                    this.showUpgradeNotice = true
                } else {
                    this.showUpgradeNotice = false
                }
            } catch (e) {
                this.showUpgradeNotice = false
            }
        }
    },
    watch: {
        loading() {
            if (this.loading) {
                let loadDiv = document.querySelector('.el-loading-spinner')
                let loadText = document.querySelector('.el-loading-text')
                if (!loadDiv || !loadDiv.firstChild || !loadText) return
                this.$refs.gifDiv.style.display = ''
                if (loadText) this.$refs.gifDiv.appendChild(loadText)
                if (loadDiv && loadDiv.firstChild) loadDiv.replaceChild(this.$refs.gifDiv, loadDiv.firstChild);
            } else {
                this.$refs.gifDiv.style.display = 'none'
            }
        }
    }
}
</script>

<style>
#app {
    background: #F4F5FA;
}

.tox-tinymce-aux {
    z-index: 99999 !important;
}

@font-face {
    font-family: MF LiHei (Noncommercial) Regular;
    src: url("./assets/ttf/MFLiHei_Noncommercial-Regular.ttf");
}

@font-face {
    font-family: DS-Digital;
    src: url("./assets/ttf/ds-digital.ttf");
}

@font-face {
    font-family: 'Alimama ShuHeiTi Bold';
    src: url("./assets/fonts/AlimamaShuHeiTi-Bold.ttf");
}

.el-loading-spinner .el-loading-text {
    margin-top: 8px !important;
    color: black !important;
    font-size: 18px !important;
}

.el-loading-spinner .circular {
    width: 100px !important;
    height: 100px !important;
}

.el-loading-mask.is-fullscreen {
    background-color: transparent;
}
</style>
<style lang="scss">
.my-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 200px;
    height: 200px;
    /*width: 100%;*/
    z-index: 2013;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    transform: translateY(-50%);

    >img {
        width: 140px;
        height: 140px;
    }

}


* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

#app {
    width: 100vw;
    height: 100vh;
    /*background-color: #020308;*/
    overflow: hidden;
}

/* 整个滚动条 */
::-webkit-scrollbar {
    /* 对应纵向滚动条的宽度 */
    width: 5px;
    /* 对应横向滚动条的宽度 */
    height: 5px;
}

/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
    // background-color: #49b1f5;
    // border-radius: 32px;
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #FFF2CC;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
    // background-color: #dbeffd;
    // border-radius: 32px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: transparent;
}

.noselect {
    -moz-user-select: none;
    /* 火狐 */
    -webkit-user-select: none;
    /* 谷歌、Safari */
    -ms-user-select: none;
    /* IE10+ */
    user-select: none;
    user-drag: none;
}
</style>
<style lang="scss" scoped>
.loading {
    z-index: 999998;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #fff, $alpha: 0.65);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .loading-name {
        width: 100px;
        height: auto;
        margin-top: 20px;
        background: white;

        img {
            width: 100%;
            height: 100%;
        }
    }

}
</style>
